export { m as default } from './index-f7e7aa8d.js';
import 'joi';